var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompanyaddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 535,
    height: 535,
    viewBox: "0 0 535 535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_32",
    x: 0,
    y: 0,
    width: 525,
    height: 525,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: -5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#717171",
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Subtraction_33",
    x: 10,
    y: 10,
    width: 525,
    height: 525,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.251
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9335",
    "data-name": "Group 9335",
    transform: "translate(11.5 11.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9334",
    "data-name": "Group 9334"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5145",
    "data-name": "Rectangle 5145",
    width: 512,
    height: 512,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9333",
    "data-name": "Group 9333",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1433",
    "data-name": "Group 1433",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.5, -21.5)",
    filter: "url(#Subtraction_32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_32-2",
    "data-name": "Subtraction 32",
    d: "M246.006,492A245.609,245.609,0,0,1,72.058,419.943a246.454,246.454,0,0,1-52.723-78.195,245.619,245.619,0,0,1,22.685-233.29A246.66,246.66,0,0,1,150.252,19.334a245.707,245.707,0,0,1,233.3,22.678,246.738,246.738,0,0,1,89.117,108.227,245.707,245.707,0,0,1-22.678,233.3,246.822,246.822,0,0,1-108.227,89.137A244.5,244.5,0,0,1,246.006,492ZM191.592,84.921,91.334,118.708a9,9,0,0,0-6.4,8.527V396.009a8.8,8.8,0,0,0,8.9,8.885l2.832-.532,94.928-36.8,106.658,37.329L398.507,371.12a8.986,8.986,0,0,0,6.406-8.54V93.82a8.8,8.8,0,0,0-8.9-8.9l-2.832.532-94.928,36.8L191.592,84.921ZM298.249,369.333h-.006v-.006l-106.651-37.5V120.482l106.658,37.5Z",
    transform: "translate(21.5 21.5)",
    fill: "rgba(255,255,255,0.71)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -21.5, -21.5)",
    filter: "url(#Subtraction_33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_33-2",
    "data-name": "Subtraction 33",
    d: "M246.006,492A245.609,245.609,0,0,1,72.058,419.943a246.454,246.454,0,0,1-52.723-78.195,245.619,245.619,0,0,1,22.685-233.29A246.66,246.66,0,0,1,150.252,19.334a245.707,245.707,0,0,1,233.3,22.678,246.738,246.738,0,0,1,89.117,108.227,245.707,245.707,0,0,1-22.678,233.3,246.822,246.822,0,0,1-108.227,89.137A244.5,244.5,0,0,1,246.006,492ZM191.592,84.921,91.334,118.708a9,9,0,0,0-6.4,8.527V396.009a8.8,8.8,0,0,0,8.9,8.885l2.832-.532,94.928-36.8,106.658,37.329L398.507,371.12a8.986,8.986,0,0,0,6.406-8.54V93.82a8.8,8.8,0,0,0-8.9-8.9l-2.832.532-94.928,36.8L191.592,84.921ZM298.249,369.333h-.006v-.006l-106.651-37.5V120.482l106.658,37.5Z",
    transform: "translate(21.5 21.5)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5146",
    "data-name": "Rectangle 5146",
    width: 512,
    height: 512,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyaddress);
export default __webpack_public_path__ + "static/media/companyaddress.62b9d388912a33a892b166b26fd07d54.svg";
export { ForwardRef as ReactComponent };